export default "__VITE_ASSET__5jQFW38Q__"